import React from 'react'

import RunRoute from './RunRoute'

import OurPartners from './OurPartners'
import RaceEntry from './RaceEntry'
import PreviousEvent from './PreviousEvent'
// import EventSignUp from './EventSignUp'
import { signUpLink } from 'constants/assets'
import useRegistrationStatus from 'hooks/useRegistrationStatus'

const Home: React.FC = () => {
    const registrationClosed = useRegistrationStatus()

    return (
        <div>
            <section
                className="relative bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: `url(assets/Kilverts-Field.jpg)` }}>
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-white/25 to-white/25 bg-white/25"></div>

                {/* Top Wave Background - Mobile */}
                <div className="block lg:hidden">
                    <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0] z-10">
                        <svg
                            className="block w-full h-[400px]"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="600 0 500 350" /* min-x min-y width height */
                            preserveAspectRatio="none">
                            <path
                                d="M0,0V80c70,30,150,50,230,30s150-90,230-90,160,60,240,80,160-20,240-30,160,40,240,30V0Z"
                                fill="#6aa4eb"
                            />
                        </svg>
                    </div>
                    <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0] z-10">
                        <svg
                            className="block w-full h-[400px]"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="600 0 500 400" /* min-x min-y width height */
                            preserveAspectRatio="none">
                            <path
                                d="M0,0V80c70,30,150,50,230,30s150-90,230-90,160,60,240,80,160-20,240-30,160,40,240,30V0Z"
                                fill="#0071c0"
                            />
                        </svg>
                    </div>
                </div>

                {/* Top Wave Background - Desktop */}
                <div className="hidden lg:block">
                    <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0] z-10">
                        <svg
                            className="block w-full h-[400px]"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="600 0 500 200" /* min-x min-y width height */
                            preserveAspectRatio="none">
                            <path
                                d="M0,0V80c70,30,150,50,230,30s150-90,230-90,160,60,240,80,160-20,240-30,160,40,240,30V0Z"
                                fill="#69b4eb"
                            />
                        </svg>
                    </div>
                    <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0] z-10">
                        <svg
                            className="block w-full h-[400px]"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="600 0 500 250" /* min-x min-y width height */
                            preserveAspectRatio="none">
                            <path
                                d="M0,0V80c70,30,150,50,230,30s150-90,230-90,160,60,240,80,160-20,240-30,160,40,240,30V0Z"
                                fill="#0071c0"
                            />
                        </svg>
                    </div>
                </div>

                {/* Header - Text */}
                <div className="absolute ml-4 mt-2 z-10">
                    <h1 className="text-3xl text-white font-extrabold sm:text-5xl">Grays Run</h1>
                    <h2 className="text-1xl text-yellow-400 font-extrabold sm:text-3xl">
                        Walk, Jog or Run
                    </h2>
                </div>

                {/* Content */}
                <div className="relative flex flex-col justify-end items-center lg:justify-center lg:items-center text-center mx-auto max-w-screen-xl px-4 pt-32 pb-16 sm:px-6 lg:h-screen min-h-[500px] z-10">
                    <div className="max-w-xl lg:max-w-5xl">
                        <h1 className="text-3xl font-extrabold sm:text-5xl">
                            Join us for our 10k and 3k runs at Kilverts Field on Sunday 6th
                            September 2026
                        </h1>
                    </div>
                    <div className="max-w-xl lg:max-w-3xl">
                        <p className="mt-4 sm:text-xl/relaxed font-bold">
                            We will also have a number of craft and food stalls on the day
                        </p>
                    </div>
                    <div>
                        {registrationClosed ? (
                            <p className="mt-8 font-semibold text-red-700">
                                Thank you to everyone who took part. Stay tuned for updates about
                                next year&apos;s event.
                            </p>
                        ) : (
                            <>
                                <a
                                    href={signUpLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mt-8 grays-run-button-light-blue text-black px-4 py-2 rounded inline-block text-center">
                                    Register
                                </a>
                                <p className="mt-3 font-semibold text-red-700">
                                    Please note that the 10k online registration will close midday,
                                    Friday, 4th September.
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </section>

            {/* <EventSignUp /> */}

            <PreviousEvent />

            <RaceEntry />

            <RunRoute />

            <div className="p-8">
                <h2 className="text-4xl md:text-6xl font-bold pb-8">Getting to the Event</h2>
                <p className="py-4">Sat Nav Postcode: RM17 6JP</p>
                <p className="py-4">
                    Parking: Pay & display car park available at Kilverts Field, Thames Road Car
                    Park, RM17 6JP (Please note only card payments accepted). Additional Off street
                    parking is also available
                </p>
                <p className="py-4">
                    Train/Bus: Only 10 minutes walk from Grays main train and bus station to the
                    starting point
                </p>
            </div>

            <OurPartners />
        </div>
    )
}

export default Home
